export const MuiTableCell = {
    styleOverrides: {
        head: {
            overflowWrap: 'break-word'
        }
    }
};

//# sourceMappingURL=table-cell.js.map